/**
 * Seasonal Planner Service
 * Frontend wrapper for /api/v1/seasonal-planner/*.
 */
import axios from 'axios';

// API base resolved via config/api.js so prod (REACT_APP_API_BASE_URL='') uses relative URLs through Nginx; localhost fallback only in dev.
import { API_BASE_URL as ROOT_API } from '../config/api';
const API_BASE_URL = `${ROOT_API}/api/v1`;

const seasonalPlannerService = {
  async generatePlan(input = {}) {
    const body = {
      month: input.month ?? null,
      start_date: input.startDate ?? null,
      dislikes: input.dislikes ?? [],
      allergies: input.allergies ?? [],
      diet_style: input.dietStyle ?? 'omnivore',
      respect_trophology: input.respectTrophology ?? true,
      rng_seed: input.rngSeed ?? null,
      batch_cooking_level: input.batchCookingLevel ?? 5,
    };
    const response = await axios.post(
      `${API_BASE_URL}/seasonal-planner/generate`,
      body,
    );
    return response.data;
  },

  async getSeasonalProduce(month) {
    const response = await axios.get(`${API_BASE_URL}/seasonal-planner/seasonal-produce/${month}`);
    return response.data;
  },

  async getBatchCookingLevels() {
    const response = await axios.get(`${API_BASE_URL}/seasonal-planner/batch-cooking-levels`);
    return response.data.levels;
  },
};

export default seasonalPlannerService;
